module.exports = __webpack_public_path__ + "media/images/products/shop/1-70ff4f53c9df70aceaec968d47317cdc.jpg";